import { OrganizationId } from 'yeself-common/typings/application/Application';
import request from 'yeself-common/utils/RequestUtils';

import EnvironmentConfiguration from 'yeself-client-common/EnvironmentConfiguration';

export const fetchReportConfiguration = (
    organizationId: OrganizationId
): ReturnType<typeof request.get> =>
    request.get(`${EnvironmentConfiguration.API_MANAGE_SLUG}/report`, {
        query: {
            organizationId,
        },
    });
